import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "area",
  standalone: false,
})
export class AreaConversionsPipe implements PipeTransform {
  transform(value: number, conversionUnits: string, digits?: number, showUnits?: boolean): string {
    if (!value && value !== 0) {
      return "Unavailable";
    }

    let result;
    // sq units
    switch (conversionUnits) {
      case "sq in-sq cm":
        result = value * 6.452;
        break;
      case "sq cm-sq in":
        result = value / 6.452;
        break;
      case "sq ft-sq m":
        result = value / 10.764;
        break;
      case "sq m-sq ft":
        result = value * 10.764;
        break;
      case "sq yd-sq m":
        result = value / 1.196;
        break;
      case "sq m-sq yd":
        result = value * 1.196;
        break;
      case "sq mi-sq km":
        result = value * 2.59;
        break;
      case "sq km-sq mi":
        result = value / 2.59;
        break;

      case "sq in-sq ft":
        result = value / 12;
        break;
      case "sq ft-sq in":
        result = value * 12;
        break;
      case "sq ft-sq yd":
        result = value / 9;
        break;
      case "sq yd-sq ft":
        result = value * 9;
        break;
      case "sq ft-sq mi":
        result = value / 27880000;
        break;
      case "sq mi-sq ft":
        result = value * 27880000;
        break;
      case "sq yd-sq mi":
        result = value / 32283100;
        break;
      case "sq mi-sq yd":
        result = value * 32283100;
        break;

      default:
        result = value;
    }

    if (digits || digits === 0) {
      result = result.toFixed(digits);
    }

    if (showUnits && conversionUnits) {
      result += ` ${conversionUnits.split("-")[1]}`;
    }

    return result;
  }
}
